module.exports = __webpack_public_path__ + "f478e63695060f4982ff7e5b9b139b8e.jpg";